import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { Spinner } from '@nvision/ui';

import { TabsLayout } from '@/components/tabs-layout';

import { LazyContract, LazyContractNew } from './components/contract';
import { LazyContracts } from './components/contracts/contracts.lazy';
import { ROUTES } from './config';

const TABS = [
  { label: 'Contracts', to: ROUTES.contracts() },
  { label: 'Dashboard', to: ROUTES.dashboard() },
];

export const routes = {
  root: {
    Component: () => (
      <TabsLayout tabs={TABS}>
        <Suspense fallback={<Spinner size="sm" />}>
          <Outlet />
        </Suspense>
      </TabsLayout>
    ),
    path: ROUTES.root(),
  },
  routes: [
    {
      Component: () => <LazyContracts />,
      path: ROUTES.contracts(),
    },
    {
      Component: () => <LazyContractNew />,
      path: ROUTES.contractNew(),
    },
    {
      Component: () => <LazyContract />,
      path: ROUTES.contract(),
    },
    {
      Component: () => null,
      path: ROUTES.dashboard(),
    },
  ],
};
